export const SET_SHOW_SIDEBAR = "SET_SHOW_SIDEBAR";
export const TOGGLE_SHOW_SIDEBAR = "TOGGLE_SHOW_SIDEBAR";
export const SET_SHOW_INNER_SIDEBAR = "SET_SHOW_INNER_SIDEBAR";
export const TOGGLE_SHOW_INNER_SIDEBAR = "TOGGLE_SHOW_INNER_SIDEBAR";
export const SET_SHOW_BACKBTN = "SET_SHOW_BACKBTN";
export const RESET_VIEW = "RESET_VIEW"; // To use in logout

export function setShowSidebar(showSidebar) {
  return {
    type: SET_SHOW_SIDEBAR,
    payload: {
      showSidebar,
    },
  };
}

export function toggleShowSidebar(showSidebar) {
  return {
    type: TOGGLE_SHOW_SIDEBAR,
    payload: {},
  };
}

export function resetView() {
  return {
    type: RESET_VIEW,
    payload: {},
  };
}

export function setShowBackButton(showBackBtn, pageName) {
  return {
    type: SET_SHOW_BACKBTN,
    payload: {
      showBackBtn,
      pageName,
    },
  };
}
